import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation UserEvaluation_update($id: ID!, $grade: Int, $isDraft: Boolean) {
    UserEvaluation_update(id: $id, grade: $grade, isDraft: $isDraft) {
      status
    }
  }
`;

const UserEvaluationUpdate = async ({ id, grade, isDraft }) =>
  graphql(mutation, {
    id,
    grade: parseInt(grade, 10),
    isDraft,
  }).then(
    // eslint-disable-next-line camelcase
    ({ UserEvaluation_update }) => UserEvaluation_update
  );

export default UserEvaluationUpdate;
